import React from 'react'
import _ from 'lodash'
import immutable from 'immutable'

import {ItemTitleBlock} from '../widgets/layout/itemtitleblock.component'
import {ItemReservationBlock} from '../widgets/layout/itemreservationblock.component'

export class TravelItem extends React.Component {
    constructor(props) {
        super(props)		

        // converting to immutable for ease of parsing
        let _tempItem = new immutable.fromJS(this.props.item)
        let _fullItem = _tempItem.get('transportation') ? _tempItem : null // full content including dep, arr, etc
        let _partialItem = _tempItem.get('transportation')  ? _tempItem.get('transportation') : _tempItem // Just the trans object
        let _isAdded = this.props.inItin ? this.props.inItin : this.props.transportation.findIndex((trans) => {
            return trans.getIn(['transportation', 'transportation_guid']) === _partialItem.get('transportation_guid') 
        })

        this.state = {
            fullItem: _fullItem,
            partialItem: _partialItem,
            segments: null
        }

        _.bindAll(this,		
	   		'addToItin',
	   		'removeFromItin',
	   		'goBack',
	   		'getSegments',
            'getTravelDetails'
        )
    }

    componentWillReceiveProps(nextProps) {
        let tempItem = new immutable.fromJS(nextProps.item)
        let tempFullItem = tempItem.get('transportation') ? tempItem.item : null // full content including dep, arr, etc
        let tempPartialItem = tempItem.get('transportation')  ? tempItem.get('transportation') : tempItem // Just the trans object

        if (this.state.partialItem.get('transportation_guid') !== tempPartialItem.get('transportation_guid') ) {
            this.setState({fullItem: tempFullItem, partialItem: tempPartialItem, segments: null}) // reset
        }
    }
    goBack() {
  	if (this.props.goBack) {
  		this.props.goBack()
  	} else {
            this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.TRAVEL, this.props.availableDetailSubSections.SEARCH)
  	}
    }

    addToItin() {
  	// this.setState({inItin:true})
        this.props.addTransportation(this.state.partialItem)
    }

    removeFromItin() {
  	// if(confirm('Are you sure you want to delete this option?')){
    	// this.setState({inItin:null})
	  	this.props.onRemoveTransportation(this.state.partialItem)
    // }
    }

    getTravelDetails() {
        if (this.state.fullItem) {
            let depName = null
            let arrName = null
            let divider = null  
            // departure name
            if (this.state.fullItem.getIn(['destDep', 'name'])) {
                depName = this.state.fullItem.getIn(['destDep', 'name'])
            } else if (this.state.fullItem.get('legDep')) {
                // find leg and get the destination name
                let legDepIndex = this.props.legs.findIndex((leg) => {
                    return leg.get('id') === this.state.fullItem.get('legDep') 
                })
                depName = this.props.legs.getIn([legDepIndex, 'destination', 'title'])
            }
            // arrival name
            if (this.state.fullItem.getIn(['destArr', 'name'])) {
                arrName = this.state.fullItem.getIn(['destArr', 'title'])
            } else if (this.state.fullItem.get('legArr')) {
                // find leg and get the destination name
                let legArrIndex = this.props.legs.findIndex((leg) => {
                    return leg.get('id') === this.state.fullItem.get('legArr') 
                })
                arrName = this.props.legs.getIn([legArrIndex, 'destination', 'name'])
            }
            if (arrName === depName) {
                arrName = null // Local
                depName = 'Local Travel'
            }
            if (depName && arrName) {
                divider = ' > '
            }
            return <div>{depName}{divider}{arrName}</div>
        } else {
            // TODO: We could potentially get this out of the legs?
            return null
        }
    }

    getSegments() {
  	let self = this
  	let segments = this.state.partialItem.get('segments').map((segment, index) => {
            switch (segment.get('segmentKind')) {
                case 'air':
                    let tOutbound = segment.get('outbound')
                    let isTrimmed = ''
                    let dispLimit = 100
          
                    let outbounds = segment.get('outbound').map((outbound, index) => {
                        let hopsDuration = 0
                        let hops = outbound.get('hops').map((hop, index) => {
                            hopsDuration += hop.get('duration')
                            if (hop.get('layoverDuration')) {
                                hopsDuration += hop.get('layoverDuration')
                            }
                            if (hop.get('airline')) {
                	if (hop.getIn(['airline', 'url'])) {
                                    return (
                                        <div key={index} className="travel-hop">		                    
                                            <div className="travel-hop-label">Flight {index + 1}</div>
                                            <div className="travel-hop-details">
                                                <div>{hop.getIn(['depPlace', 'code'])} > {hop.getIn(['arrPlace', 'code'])}</div>
                                                <div>departs {hop.get('depTime')} | arrive {hop.get('arrTime')}</div>
                                                <div><a href={hop.getIn(['airline', 'url'])}>{hop.getIn(['airline', 'name'])}</a></div>
                                            </div>
                                        </div>
		                )
                	} else {
                		return (
                    <div key={index} className="travel-hop">
                        <div className="travel-hop-label">Flight {index + 1}</div>
                        <div className="travel-hop-details">
                            <div>{hop.getIn(['depPlace', 'code'])} > {hop.getIn(['arrPlace', 'code'])}</div>
                            <div>departs {hop.get('depTime')} | arrive {hop.get('arrTime')}</div>
                            <div>{hop.getIn(['airline', 'name'])}</div>
                        </div>
                    </div>
		                )
                	}
                            }
                        })
                        return <div key={index} className="travel-leg"><div className="travel-leg-header">Option {index + 1}</div>{hops}<div className="leg-length">{self.props.getDuration(hopsDuration)} Total Duration</div></div>
                    })
                    return (
                        <div key={index}>
                            <h1>{index + 1}: {segment.getIn(['vehicle', 'name'])}</h1>
                            <div>*Showing sample flight options</div>
                            {outbounds}
                        </div>
                    )
                    return 
                    break
                default:
                    let agencies = ''
                    let numSteps = ''
                    let vehicleName = ''
                    if (segment.get('agencies')) {
            	agencies = segment.get('agencies').map((agency) => {
            		// TODO: There may be other entries here dependent on type of transit, this is train typically
            		if (agency.get('lineNames')) {
	            		return agency.get('lineNames').map((line, index) => {
		            		return <div className="travel-agency" key={index}>{line}</div>            			
	            		})            		
	            	}
            	})
                    }
                    if (segment.getIn(['stops', 'length'])) {
                        numSteps = <div className="travel-stops">{segment.getIn(['stops', 'length'])} stops</div>
                    }
                    if (segment.getIn(['vehicle', 'name'])) {
                        vehicleName = segment.getIn(['vehicle', 'name'])
                    }
                    return (
                        <div key={index}>
                            <h1>{index + 1}: {vehicleName} {self.props.getDuration(segment.get('transferDuration') + segment.get('transitDuration'))}</h1>
                            {agencies}
                            {numSteps}
                        </div>
                    )
                    break
            }
        })
        return (
            <div className="travel-detail-segments">
                {segments}
            </div>
        )
    }

    render() {
        return (
            <div className="view-area">
                <div className="view-left-col">
                    <a onClick={() => this.goBack() } className="btn">Back</a>
                </div>
                <div className="view-center">
                    <ItemTitleBlock item={ this.state.partialItem } inItin={this.props.inItin} transportation={this.props.transportation} removeFromItin={this.removeFromItin} addToItin={this.addToItin}/>					
                    <div className="travel-detail-segments">
                        {this.getTravelDetails()}
                        <ItemReservationBlock label='Reservation Details' item={ this.state.partialItem }/> 
                        {this.getSegments()}
                    </div>
                </div>
                <div className="view-right-col"/>
            </div>
        )
    }
}